module.exports = __webpack_public_path__ + "static/media/bottleWhite.836865a7.png";